const state = () => ({
  dialogTitle: '',
  dialogButtons: [],
  dialogLoading: false,
  dialogLeftHeaderIcon: '',
  dialogHeaderType: 'navigation',
  identifier: '',
  goPayId: '',
  questionTariff: {},
  backendPaymentMethodGroups: []
  // backendPaymentMethodGroups: [{"title":"Platebn\u00ed kartou on-line","methods":[{"id":3,"name":"card","platformId":1,"paymentProviderId":2,"sortOrder":1000,"enabled":true,"categoryId":1,"swiftCode":0,"description":"Vysoce zabezpe\u010den\u00e1 platebn\u00ed br\u00e1na, schv\u00e1lena dle pravidel MasterCard a VISA, provozovan\u00e1 spole\u010dnost\u00ed GoPay. V p\u0159\u00edpad\u011b zam\u00edtnut\u00ed transakce se informujte na d\u016fvod zam\u00edtnut\u00ed p\u0159\u00edmo u vydavatele karty. Po p\u0159ijet\u00ed platby bude v\u00e1\u0161 dotaz zpracov\u00e1n.","priceDescription":"bez poplatku","title":"Platebn\u00ed karta"}]},{"title":"Online bankovn\u00ed platbou","methods":[{"id":13,"name":"onlineCeskaSporitelna","platformId":1,"paymentProviderId":2,"sortOrder":1000,"enabled":true,"categoryId":2,"swiftCode":5,"description":"Rychl\u00e1 a bezpe\u010dn\u00e1 platba pro klienty \u010cesk\u00e9 spo\u0159itelny. Obl\u00edben\u00e1 bankovn\u00ed platba s p\u0159edvypln\u011bn\u00fdm platebn\u00edm p\u0159\u00edkazem. Platba prob\u00edh\u00e1 online a v\u017edy v r\u00e1mci uveden\u00e9 bankovn\u00ed instituce.","priceDescription":"bez poplatku","title":"Platba 24 - \u010cesk\u00e1 spo\u0159itelna"},{"id":10,"name":"onlineKomercniBanka","platformId":1,"paymentProviderId":2,"sortOrder":1100,"enabled":true,"categoryId":2,"swiftCode":2,"description":"Rychl\u00e1 a bezpe\u010dn\u00e1 platba pro klienty Komer\u010dn\u00ed banky. Obl\u00edben\u00e1 bankovn\u00ed platba s p\u0159edvypln\u011bn\u00fdm platebn\u00edm p\u0159\u00edkazem. Platba prob\u00edh\u00e1 online a v\u017edy v r\u00e1mci uveden\u00e9 bankovn\u00ed instituce.","priceDescription":"bez poplatku","title":"MojePlatba - Komer\u010dn\u00ed banka"},{"id":15,"name":"onlineCSOB","platformId":1,"paymentProviderId":2,"sortOrder":1200,"enabled":true,"categoryId":2,"swiftCode":7,"description":"Rychl\u00e1 a bezpe\u010dn\u00e1 platba pro klienty \u010cSOB. Obl\u00edben\u00e1 bankovn\u00ed platba s p\u0159edvypln\u011bn\u00fdm platebn\u00edm p\u0159\u00edkazem. Platba prob\u00edh\u00e1 online a v\u017edy v r\u00e1mci uveden\u00e9 bankovn\u00ed instituce.","priceDescription":"bez poplatku","title":"\u010cSOB"},{"id":12,"name":"onlineFio","platformId":1,"paymentProviderId":2,"sortOrder":1300,"enabled":true,"categoryId":2,"swiftCode":4,"description":"Rychl\u00e1 a bezpe\u010dn\u00e1 platba pro klienty Fio banky. Obl\u00edben\u00e1 bankovn\u00ed platba s p\u0159edvypln\u011bn\u00fdm platebn\u00edm p\u0159\u00edkazem. Platba prob\u00edh\u00e1 online a v\u017edy v r\u00e1mci uveden\u00e9 bankovn\u00ed instituce.","priceDescription":"bez poplatku","title":"Fio banka"},{"id":11,"name":"onlineMbank","platformId":1,"paymentProviderId":2,"sortOrder":1400,"enabled":true,"categoryId":2,"swiftCode":3,"description":"Rychl\u00e1 a bezpe\u010dn\u00e1 platba pro klienty mBank. Obl\u00edben\u00e1 bankovn\u00ed platba s p\u0159edvypln\u011bn\u00fdm platebn\u00edm p\u0159\u00edkazem. Platba prob\u00edh\u00e1 online a v\u017edy v r\u00e1mci uveden\u00e9 bankovn\u00ed instituce.","priceDescription":"bez poplatku","title":"mPen\u00edze - mBank"},{"id":9,"name":"onlineRaiffeisen","platformId":1,"paymentProviderId":2,"sortOrder":1500,"enabled":true,"categoryId":2,"swiftCode":1,"description":"Rychl\u00e1 a bezpe\u010dn\u00e1 platba pro klienty Raiffeisenbank. Obl\u00edben\u00e1 bankovn\u00ed platba s p\u0159edvypln\u011bn\u00fdm platebn\u00edm p\u0159\u00edkazem. Platba prob\u00edh\u00e1 online a v\u017edy v r\u00e1mci uveden\u00e9 bankovn\u00ed instituce.","priceDescription":"bez poplatku","title":"ePlatby - Raiffeisenbank"},{"id":16,"name":"onlinePostovniSporitelna","platformId":1,"paymentProviderId":2,"sortOrder":1600,"enabled":true,"categoryId":2,"swiftCode":8,"description":"Rychl\u00e1 a bezpe\u010dn\u00e1 platba pro klienty Po\u0161tovn\u00ed spo\u0159itelny. Obl\u00edben\u00e1 bankovn\u00ed platba s p\u0159edvypln\u011bn\u00fdm platebn\u00edm p\u0159\u00edkazem. Platba prob\u00edh\u00e1 online a v\u017edy v r\u00e1mci uveden\u00e9 bankovn\u00ed instituce.","priceDescription":"bez poplatku","title":"Po\u0161tovn\u00ed spo\u0159itelna"},{"id":14,"name":"onlineUniCreditBank","platformId":1,"paymentProviderId":2,"sortOrder":1700,"enabled":true,"categoryId":2,"swiftCode":6,"description":"Rychl\u00e1 a bezpe\u010dn\u00e1 platba pro klienty UniCredit Bank. Obl\u00edben\u00e1 bankovn\u00ed platba s p\u0159edvypln\u011bn\u00fdm platebn\u00edm p\u0159\u00edkazem. Platba prob\u00edh\u00e1 online a v\u017edy v r\u00e1mci uveden\u00e9 bankovn\u00ed instituce.","priceDescription":"bez poplatku","title":"UniCredit Bank"}]},{"title":"Elektronickou pen\u011b\u017eenkou","methods":[{"id":5,"name":"paypal","platformId":1,"paymentProviderId":2,"sortOrder":1200,"enabled":true,"categoryId":3,"swiftCode":0,"description":"Tato platebn\u00ed metoda umo\u017e\u0148uje Paypal registrovan\u00fdm z\u00e1kazn\u00edk\u016fm prov\u00e1d\u011bt online platby pohodln\u00fdm a bezpe\u010dn\u00fdm zp\u016fsobem bez nutnosti poskytovat p\u0159i placen\u00ed osobn\u00ed a finan\u010dn\u00ed \u00fadaje.","priceDescription":"bez poplatku","title":"PayPal"},{"id":6,"name":"gopay","platformId":1,"paymentProviderId":2,"sortOrder":1300,"enabled":true,"categoryId":3,"swiftCode":0,"description":"Tato platebn\u00ed metoda umo\u017e\u0148uje GoPay registrovan\u00fdm z\u00e1kazn\u00edk\u016fm prov\u00e1d\u011bt online platby pohodln\u00fdm a bezpe\u010dn\u00fdm zp\u016fsobem bez nutnosti poskytovat p\u0159i placen\u00ed osobn\u00ed a finan\u010dn\u00ed \u00fadaje.","priceDescription":"bez poplatku","title":"GoPay"}]},{"title":"Jinak","methods":[{"id":4,"name":"sms","platformId":1,"paymentProviderId":2,"sortOrder":1100,"enabled":true,"categoryId":4,"swiftCode":0,"description":"Platby jsou strh\u00e1v\u00e1ny z kreditu p\u0159edplacen\u00e9 karty nebo p\u0159i\u010dteny k vy\u00fa\u010dtov\u00e1n\u00ed u tarifn\u00edch klient\u016f. Upozor\u0148ujeme, \u017ee premium sms mus\u00edte m\u00edt aktivovanou, pokud m\u00e1te firemn\u00ed \u010d\u00edslo nemus\u00ed b\u00fdt tento typ platby povolen.","priceDescription":"bez poplatku","title":"Premium SMS"},{"id":2,"name":"voucher","platformId":1,"paymentProviderId":1,"sortOrder":9000,"enabled":true,"categoryId":4,"swiftCode":0,"description":"Pouk\u00e1zky nebo vouchery uL\u00e9ka\u0159e.cz lze z\u00edskat p\u0159i r\u016fzn\u00fdch akc\u00edch a p\u0159\u00edle\u017eitostech. Pro uplatn\u011bn\u00ed sta\u010d\u00ed zadat k\u00f3d.","priceDescription":"bez poplatku","title":"Pouk\u00e1zkou uL\u00e9ka\u0159e.cz"}]}]
});

const getters = {
  dialogTitle(state) {
    return state.dialogTitle;
  },
  dialogButtons(state) {
    return state.dialogButtons;
  },
  dialogLoading(state) {
    return state.dialogLoading;
  },
  dialogLeftHeaderIcon(state) {
    return state.dialogLeftHeaderIcon;
  },
  dialogHeaderType(state) {
    return state.dialogHeaderType;
  },
  identifier(state) {
    return state.identifier;
  },
  questionTariff(state) {
    return state.questionTariff;
  },
  backendPaymentMethodGroups(state) {
    return state.backendPaymentMethodGroups;
  },
  goPayId(state) {
    return state.goPayId;
  }
};

const mutations = {
  setDialogTitle(state, payload) {
    state.dialogTitle = payload;
  },
  setDialogButtons(state, payload) {
    state.dialogButtons = payload;
  },
  setDialogLoading(state, payload) {
    state.dialogLoading = payload;
  },
  setDialogLeftHeaderIcon(state, payload) {
    state.dialogLeftHeaderIcon = payload;
  },
  setDialogHeaderType(state, payload) {
    state.dialogHeaderType = payload;
  },
  setIdentifier(state, payload) {
    state.identifier = payload;
  },
  setQuestionTariff(state, payload) {
    state.questionTariff = payload;
  },
  setBackendPaymentMethodGroups(state, payload) {
    state.backendPaymentMethodGroups = payload;
  },
  setGoPayId(state, payload) {
    state.goPayId = payload;
  },
  resetStore(storeState) {
    Object.assign(storeState, state());
  }
};

const actions = {
  setDialogTitle({ commit }, payload) {
    commit('setDialogTitle', payload);
  },
  setDialogButtons({ commit }, payload) {
    commit('setDialogButtons', payload);
  },
  setDialogLoading({ commit }, payload) {
    commit('setDialogLoading', payload);
  },
  setDialogLeftHeaderIcon({ commit }, payload) {
    commit('setDialogLeftHeaderIcon', payload);
  },
  setDialogHeaderType({ commit }, payload) {
    commit('setDialogHeaderType', payload);
  },
  setIdentifier({ commit }, payload) {
    commit('setIdentifier', payload);
  },
  setQuestionTariff({ commit }, payload) {
    commit('setQuestionTariff', payload);
  },
  setBackendPaymentMethodGroups({ commit }, payload) {
    commit('setBackendPaymentMethodGroups', payload);
  },
  setGoPayId({ commit }, payload) {
    commit('setGoPayId', payload);
  }
};

export const goPay = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
